import apiClient from './apiClient';

export const authApi = {
  login: async (email, password) => {
    const response = await apiClient.post('/auth/login', { email, password }, {
      suppressGlobalErrorToast: true
    });
    return response.data;
  },

  register: async (email, password, fullName = null, promoCode = null) => {
    const response = await apiClient.post('/auth/register', {
      email,
      password,
      ...(fullName && { full_name: fullName }),
      ...(promoCode?.trim() && { promo_code: promoCode.trim() }),
    }, {
      suppressGlobalErrorToast: true
    });
    return response.data;
  },

  getMe: async (config = {}) => {
    const response = await apiClient.get('/auth/me', {
      suppressGlobalErrorToast: true,
      ...config,
    });
    return response.data;
  },

  getCapabilities: async () => {
    const response = await apiClient.get('/auth/me/capabilities');
    return response.data;
  },

  getPlans: async () => {
    const response = await apiClient.get('/auth/plans', {
      suppressGlobalErrorToast: true
    });
    return response.data;
  },

  updateMe: async (data) => {
    const response = await apiClient.patch('/auth/me', data);
    return response.data;
  },

  checkWhitelist: async (email) => {
    const response = await apiClient.post(
      '/auth/whitelist/check',
      { email },
      { suppressGlobalErrorToast: true }
    );
    return response.data;
  },

  checkSignup: async (email, promoCode = null) => {
    const response = await apiClient.post(
      '/auth/signup/check',
      {
        email,
        ...(promoCode?.trim() && { promo_code: promoCode.trim() }),
      },
      { suppressGlobalErrorToast: true }
    );
    return response.data;
  },

  submitAccessRequest: async (data) => {
    const response = await apiClient.post('/auth/access-requests', data, {
      suppressGlobalErrorToast: true,
    });
    return response.data;
  },

  redeemPromoCode: async (code, email) => {
    const response = await apiClient.post(
      '/auth/promo-codes/redeem',
      { code, email },
      { suppressGlobalErrorToast: true }
    );
    return response.data;
  },
};
